// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sale-tag[data-v-0d77ca95]{position:absolute;-webkit-transform-origin:top center;transform-origin:top center;background:red;top:0;clip-path:polygon(50% 0,82.6% 11.1%,100% 39.6%,93.8% 81.9%,68.1% 100%,31.9% 100%,6.3% 81.9%,0 39.6%,17.4% 11.1%)}", ""]);
// Exports
module.exports = exports;
